﻿import { formateTime } from 'common/commonFunctions';
import Icon from 'components/AppIcon';
import Button from 'components/ui/Button';
import { useState } from 'react';
const WorkSchedule = ({ data, onSave, isLoading }) => {
  const [isScheduleModalOpen, setIsScheduleModalOpen] = useState(false);
  const [workSchedule, setWorkSchedule] = useState({
    day_start_time: data?.day_start_time,
    break_start_time: data?.break_start_time,
    break_end_time: data?.break_end_time,
    day_end_time: data?.day_end_time,
  });
  const saveWorkSchedule = (workSchedule) => {
    onSave(workSchedule);
    setIsScheduleModalOpen(false);
  };
  return (
    <div className="bg-surface rounded-lg border border-border p-4 mb-6">
      <div className="flex justify-between items-center mb-4">
        <div>
          <h3 className="text-lg font-medium text-text-primary">Work Schedule Configuration</h3>
          <p className="text-sm text-text-secondary">
            Configure daily work hours for leave calculations
          </p>
        </div>
        <button
          onClick={() => setIsScheduleModalOpen(true)}
          className="px-4 py-2 bg-primary text-white rounded-lg hover:bg-primary-600 transition-colors duration-200 flex items-center space-x-2"
        >
          <Icon name="Settings" size={16} />
          <span>Configure Schedule</span>
        </button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="text-center p-3 bg-secondary-50 rounded-lg">
          <div className="text-2xl font-bold text-primary">{formateTime(data?.day_start_time)}</div>
          <div className="text-sm text-text-secondary">Day Start Time</div>
        </div>

        <div className="text-center p-3 bg-secondary-50 rounded-lg">
          <div className="text-2xl font-bold text-primary">
            {formateTime(data?.break_start_time)}
            <span className="mx-2">–</span>
            {formateTime(data?.break_end_time)}
          </div>
          <div className="text-sm text-text-secondary">Break Time</div>
        </div>
        <div className="text-center p-3 bg-secondary-50 rounded-lg">
          <div className="text-2xl font-bold text-primary">{formateTime(data?.day_end_time)}</div>
          <div className="text-sm text-text-secondary">Day End Time</div>
        </div>
      </div>
      {/* Work Schedule Configuration Modal */}
      {isScheduleModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 w-full max-w-md mx-4">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-lg font-medium text-text-primary">Configure Work Schedule</h3>
              <button
                onClick={() => setIsScheduleModalOpen(false)}
                className="text-text-secondary hover:text-text-primary"
              >
                <Icon name="X" size={20} />
              </button>
            </div>

            <form
              onSubmit={(e) => {
                e.preventDefault();
                saveWorkSchedule(workSchedule);
                setIsScheduleModalOpen(false);
              }}
              className="space-y-4"
            >
              <div>
                <label className="block text-sm font-medium text-text-primary mb-2">
                  Day Start Time
                </label>
                <input
                  type="time"
                  value={workSchedule?.day_start_time}
                  onChange={(e) =>
                    setWorkSchedule((prev) => ({ ...prev, day_start_time: e.target.value }))
                  }
                  className="w-full p-2 border border-border rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500"
                  required
                />
              </div>

              <label className="block text-sm font-medium text-text-primary mb-2">
                Break Start & End Time
              </label>
              <div className="flex space-x-4">
                <input
                  type="time"
                  value={workSchedule?.break_start_time}
                  onChange={(e) =>
                    setWorkSchedule((prev) => ({ ...prev, break_start_time: e.target.value }))
                  }
                  className="w-full p-2 border border-border rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500"
                  required
                />
                <input
                  type="time"
                  value={workSchedule?.break_end_time}
                  onChange={(e) =>
                    setWorkSchedule((prev) => ({ ...prev, break_end_time: e.target.value }))
                  }
                  className="w-full p-2 border border-border rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500"
                  required
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-text-primary mb-2">
                  Day End Time
                </label>
                <input
                  type="time"
                  value={workSchedule?.day_end_time}
                  onChange={(e) =>
                    setWorkSchedule((prev) => ({ ...prev, day_end_time: e.target.value }))
                  }
                  className="w-full p-2 border border-border rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500"
                  required
                />
              </div>

              <div className="flex justify-end space-x-3 pt-4">
                <button
                  type="button"
                  onClick={() => setIsScheduleModalOpen(false)}
                  className="px-4 py-2 text-text-secondary hover:text-text-primary transition-colors duration-200"
                >
                  Cancel
                </button>
                <Button
                  type="submit"
                  disabled={
                    isLoading ||
                    (workSchedule.day_start_time === data?.day_start_time &&
                      workSchedule.break_start_time === data?.break_start_time &&
                      workSchedule.break_end_time === data?.break_end_time &&
                      workSchedule.day_end_time === data?.day_end_time)
                  }
                  loading={isLoading}
                >
                  Save Schedule
                </Button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default WorkSchedule;
